import { TypedUseSelectorHook, useSelector as reduxUseSelector } from 'react-redux';
import type { RootState } from '../stores/store';

export const useSelector: TypedUseSelectorHook<RootState> = reduxUseSelector;
